import { CALL_API } from "../api.middleware";

import {
  GENERATE_ARN_LINK,
  GENERATE_ARN_LINK_FAILED,
  GENERATE_ARN_LINK_SUCCESS,
} from "../types/generatearn";

export const generateUrl = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GenerateDistLinks",
        params,
        method: "GET",
        types: [
          GENERATE_ARN_LINK,
          GENERATE_ARN_LINK_SUCCESS,
          GENERATE_ARN_LINK_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const validateEuin = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_EUINValidation_Mirae",
        params,
        method: "GET",
        types: [],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const EuinValidation = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Validate_Euin",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};